var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.5H19.5C19.7652 2.5 20.0196 2.60536 20.2071 2.79289C20.3946 2.98043 20.5 3.23478 20.5 3.5V22.5C20.5 22.7652 20.3946 23.0196 20.2071 23.2071C20.0196 23.3946 19.7652 23.5 19.5 23.5H4.5C4.23478 23.5 3.98043 23.3946 3.79289 23.2071C3.60536 23.0196 3.5 22.7652 3.5 22.5V3.5C3.5 3.23478 3.60536 2.98043 3.79289 2.79289C3.98043 2.60536 4.23478 2.5 4.5 2.5H5.5",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5C14 1.96957 13.7893 1.46086 13.4142 1.08579C13.0391 0.710714 12.5304 0.5 12 0.5C11.4696 0.5 10.9609 0.710714 10.5858 1.08579C10.2107 1.46086 10 1.96957 10 2.5H8C7.86739 2.5 7.74021 2.55268 7.64645 2.64645C7.55268 2.74021 7.5 2.86739 7.5 3V5C7.5 5.13261 7.55268 5.25979 7.64645 5.35355C7.74021 5.44732 7.86739 5.5 8 5.5H16C16.1326 5.5 16.2598 5.44732 16.3536 5.35355C16.4473 5.25979 16.5 5.13261 16.5 5V3C16.5 2.86739 16.4473 2.74021 16.3536 2.64645C16.2598 2.55268 16.1326 2.5 16 2.5H14Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48273 10.9247C7.78273 11.9707 7.02273 13.6077 9.86973 15.3777C10.1617 18.7207 11.7847 18.8977 13.6697 17.7407C15.4007 16.6797 17.1697 13.1157 17.0847 10.4847C17.0824 10.4082 17.0625 10.3332 17.0266 10.2656C16.9908 10.198 16.9399 10.1396 16.8779 10.0948C16.8158 10.0499 16.7443 10.0199 16.6689 10.0071C16.5935 9.99425 16.5161 9.99889 16.4427 10.0207C13.8467 10.7897 11.4677 9.70666 9.48273 10.9247Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.9977C6 19.9977 10.46 13.3387 14.268 12.4737",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.3d05dfede64ad1c92d2d258ac4ff8ac2.svg";
export { ForwardRef as ReactComponent };